import { getUserbyId } from './getUserById';
import { payrollGetSetup } from './getPayrollSetup';
import { getSalaryDetails } from './getSalaryDetails';
import { getUserByPeopleIds } from './getMultipleUsersById';
export default { getUserbyId, payrollGetSetup, getSalaryDetails, getUserByPeopleIds };
